/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StudyQueryVariables = Types.Exact<{ [key: string]: never }>;

export type StudyQuery = {
  __typename?: 'Query';
  study: { __typename?: 'Study'; _id: string; name: string; thisProgramIsBased?: string | null; allowSocialActivity: boolean; maxNumberOfActivities: number };
};

export const StudyDocument = gql`
  query study {
    study {
      _id
      name
      thisProgramIsBased
      allowSocialActivity
      maxNumberOfActivities
    }
  }
`;

/**
 * __useStudyQuery__
 *
 * To run a query within a React component, call `useStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudyQuery(baseOptions?: Apollo.QueryHookOptions<StudyQuery, StudyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StudyQuery, StudyQueryVariables>(StudyDocument, options);
}
export function useStudyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudyQuery, StudyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StudyQuery, StudyQueryVariables>(StudyDocument, options);
}
export type StudyQueryHookResult = ReturnType<typeof useStudyQuery>;
export type StudyLazyQueryHookResult = ReturnType<typeof useStudyLazyQuery>;
export type StudyQueryResult = Apollo.QueryResult<StudyQuery, StudyQueryVariables>;
